import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6, default as _styled7, default as _styled8, default as _styled9, default as _styled10 } from "styled-components";
import React from "react";
import { Link } from "~/features/ui/link";
import { Headline } from "~/features/ui/headline";
import { IconButton } from "~/features/ui/icon-button";
import Plus from "~/public/icons/plus.svg";
export type ShopCardProps = {
  media?: React.ReactNode;
  title?: string | null;
  price?: string | null;
  url?: string | null;
  /** Size options — shown as chips at the bottom of the card only when there is a choice. */
  sizes?: string[] | null;
  soldOut?: boolean | null;
};
export function ShopCard({
  media,
  title,
  price,
  url,
  sizes,
  soldOut
}: ShopCardProps) {
  const showSizes = (sizes?.length ?? 0) > 1;
  const content =
  // Tint spans the whole card — image and footer (title / price / size options).
  <_StyledDiv $_css={[{
    "display": "flex",
    "flex": "1 1 0%",
    "flexDirection": "column",
    "overflow": "hidden",
    "borderRadius": "2px",
    "backgroundColor": "#0007040D"
  }]}>
      <_StyledDiv2 $_css2={[{
      "position": "relative"
    }]}>
        {/* Plus affordance, top-right per design. */}
        <_StyledDiv3 $_css3={[{
        "position": "absolute",
        "right": "var(--spacing-sm)",
        "top": "var(--spacing-sm)",
        "zIndex": "10"
      }]}>
          <IconButton as="div" icon={{
          component: Plus
        }} />
        </_StyledDiv3>

        {media}
      </_StyledDiv2>

      <_StyledDiv4 $_css4={[{
      "display": "flex",
      "flex": "1 1 0%",
      "flexDirection": "column",
      "gap": "0.8rem",
      "paddingLeft": "var(--spacing-lg)",
      "paddingRight": "var(--spacing-lg)",
      "paddingBottom": "var(--spacing-lg)",
      "paddingTop": "var(--spacing-md)"
    }]}>
        {title && <_StyledHeadline type="h2" text={title} />}
        {/* Footer row: price left, size chips right (only when there is a choice). */}
        <_StyledDiv5 $_css5={[{
        "display": "flex",
        "alignItems": "center",
        "justifyContent": "space-between",
        "gap": "1.6rem"
      }]}>
          {price && <_StyledSpan $_css6={[{
          "fontSize": "1.6rem",
          "lineHeight": "1.5",
          "fontWeight": "400",
          "color": "var(--text-primary)",
          "@media (min-width: 1024px)": {
            "fontSize": "1.8rem",
            "lineHeight": "1.5",
            "letterSpacing": "0.018rem",
            "fontWeight": "400"
          }
        }]}>
              {soldOut ? `${price} · Sold out` : price}
            </_StyledSpan>}
          {showSizes && <_StyledDiv6 $_css7={[{
          "display": "flex",
          "flexWrap": "wrap",
          "justifyContent": "flex-end",
          "gap": "0.4rem"
        }]}>
              {sizes!.map(size => <_StyledSpan2 key={size} $_css8={[{
            "borderRadius": "2px",
            "backgroundColor": "#0007044D",
            "paddingLeft": "1.2rem",
            "paddingRight": "1.2rem",
            "paddingTop": "0.8rem",
            "paddingBottom": "0.8rem",
            "--tw-text-opacity": "1",
            "color": "rgb(255 255 255 / var(--tw-text-opacity))"
          }, {
            "fontSize": "1.4rem",
            "lineHeight": "1.5",
            "letterSpacing": "0.014000000000000002rem",
            "fontWeight": "400",
            "@media (min-width: 1024px)": {
              "fontSize": "1.4rem",
              "lineHeight": "1.5",
              "letterSpacing": "0.014000000000000002rem",
              "fontWeight": "400"
            }
          }]}>
                  {size}
                </_StyledSpan2>)}
            </_StyledDiv6>}
        </_StyledDiv5>
      </_StyledDiv4>
    </_StyledDiv>;
  return url ? <_StyledLink href={url}>
      {content}
    </_StyledLink> : content;
}
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  componentId: "sc-sf-1pvhu5x-0"
})`${p => p.$_css}`;
var _StyledDiv2 = _styled2("div").withConfig({
  componentId: "sc-sf-1pvhu5x-1"
})`${p => p.$_css2}`;
var _StyledDiv3 = _styled3("div").withConfig({
  componentId: "sc-sf-1pvhu5x-2"
})`${p => p.$_css3}`;
var _StyledDiv4 = _styled4("div").withConfig({
  componentId: "sc-sf-1pvhu5x-3"
})`${p => p.$_css4}`;
var _StyledHeadline = _styled5(Headline).withConfig({
  componentId: "sc-sf-1pvhu5x-4"
})({
  "fontSize": "2rem",
  "lineHeight": "1.3",
  "letterSpacing": "0.02rem",
  "fontWeight": "400",
  "@media (min-width: 1024px)": {
    "fontSize": "2.4rem",
    "lineHeight": "1.3",
    "letterSpacing": "0.024rem",
    "fontWeight": "400"
  }
});
var _StyledDiv5 = _styled6("div").withConfig({
  componentId: "sc-sf-1pvhu5x-5"
})`${p => p.$_css5}`;
var _StyledSpan = _styled7("span").withConfig({
  componentId: "sc-sf-1pvhu5x-6"
})`${p => p.$_css6}`;
var _StyledDiv6 = _styled8("div").withConfig({
  componentId: "sc-sf-1pvhu5x-7"
})`${p => p.$_css7}`;
var _StyledSpan2 = _styled9("span").withConfig({
  componentId: "sc-sf-1pvhu5x-8"
})`${p => p.$_css8}`;
var _StyledLink = /*#__PURE__*/_styled10(Link).withConfig({
  displayName: "shop-card___StyledLink",
  componentId: "sc-bl0hg1-0"
})({
  "position": "relative",
  "display": "flex",
  "height": "100%",
  "flexDirection": "column"
});